module.exports = __webpack_public_path__ + "static/media/OnBoarding_banor_tpOnboardingOverallt.340d92ad.png";